import style from "./index.module.css";

const AvailableColors = ({ colors }: ComponentPropsType) => {
  return (
    <div className={style.all_colors}>
      {colors.map((color, index) => (
        <div key={index} className={style.single_color}>
          <div
            style={
              color.type === "color" && color.code
                ? { backgroundColor: color.code }
                : {}
            }
          >
            {color.type === "special" && color.image && (
              <img src={color.image} alt="" />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AvailableColors;

export type ColorType = {
  type: "color" | "special";
  code?: string;
  image?: string;
}[];

type ComponentPropsType = {
  colors: ColorType;
};
